"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crypto = require("crypto");

var _elliptic = require("elliptic"); // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
// handles crypto


if (typeof window === "undefined") {
  var TextEncoder = require('util').TextEncoder;

  var TextDecoder = require('util').TextDecoder;
} else {
  var TextEncoder = window.TextEncoder;
  var TextDecoder = window.TextDecoder;
}

var Crypto =
/*#__PURE__*/
function () {
  function Crypto() {
    _classCallCheck(this, Crypto);
  }

  _createClass(Crypto, [{
    key: "generateRandomIV",

    /**
     * @returns {number} random values
     */
    value: function generateRandomIV() {
      return (0, _crypto.randomBytes)(16);
    }
  }, {
    key: "privateToPublicKey",
    value: function privateToPublicKey(privateKey) {
      var secp256k1 = new _elliptic.ec("secp256k1"); // eslint-disable-line

      var buffer = Buffer.from(privateKey.slice(2), "hex");
      var ecKey = secp256k1.keyFromPrivate(buffer);
      var publicKey = "0x" + ecKey.getPublic(false, 'hex').slice(2);
      return publicKey;
    }
    /**
     * Calculates shared secret
     * @calculateSharedSecret
     * @param {any} privateKey private key
     * @param {any} recipientPublicKey recipient public key
     * @returns {string} secret
     */

  }, {
    key: "calculateSharedSecret",
    value: function calculateSharedSecret(privateKey, recipientPublicKey) {
      var pk = privateKey.substring(2, 66);
      var pub = recipientPublicKey.substring(2, 130);

      if (pk.length !== 64) {
        throw new Error('private key must be a 32 byte hex string ' + privateKey);
      }

      if (pub.length !== 128) {
        throw new Error('public key must be a 64 byte hex string ' + recipientPublicKey);
      }

      var sender = (0, _crypto.createECDH)('secp256k1');
      sender.setPrivateKey(pk, 'hex');
      return sender.computeSecret("04" + pub, 'hex').toString('hex');
    }
    /**
     * 
     * @param {any} string to encrypt
     * @param {any} password to use
     * @param {any} iv initialization vector
     * @returns {any} encrypted string
     */

  }, {
    key: "encryptString",
    value: function encryptString(string, password, iv) {
      return this.encryptBuffer(Buffer.from(string, 'utf8'), password, iv).then(function (encryptedBuffer) {
        return encryptedBuffer.toString('hex');
      });
    }
    /**
     * Decrypt string
     * @param {any} string encrypted string
     * @param {any} password to use
     * @param {any} iv initialization vector
     * @returns {string} decrypted string 
     */

  }, {
    key: "decryptString",
    value: function decryptString(string, password, iv) {
      var decryptedBuffer = this.decryptBuffer(Buffer.from(string, 'hex'), password, iv);
      return new TextDecoder().decode(decryptedBuffer);
    }
  }, {
    key: "encryptBuffer",
    value: function encryptBuffer(buffer, password, iv) {
      return new Promise(function (resolve, reject) {
        var cipher = (0, _crypto.createCipheriv)('aes-256-ctr', Buffer.from(password.substring(2), 'hex'), iv);
        var crypted = Buffer.concat([cipher.update(buffer), cipher.final()]);
        resolve(crypted);
      });
    }
  }, {
    key: "decryptBuffer",
    value: function decryptBuffer(buffer, password, iv) {
      var decipher = (0, _crypto.createDecipheriv)('aes-256-ctr', Buffer.from(password.substring(2), 'hex'), iv);
      var dec = Buffer.concat([decipher.update(buffer), decipher.final()]);
      return dec;
    }
  }]);

  return Crypto;
}();

var _default = new Crypto();

exports.default = _default;
module.exports = exports.default;